import { render, staticRenderFns } from "./ModalEnabledPages.vue?vue&type=template&id=f15dcb22"
import script from "./ModalEnabledPages.vue?vue&type=script&lang=js"
export * from "./ModalEnabledPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports